function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#2D2D2D"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.228 2.18c-3.446 0-6.239 2.882-6.239 6.438 0 3.557 2.793 6.44 6.24 6.44 3.445 0 6.238-2.883 6.238-6.44 0-3.556-2.793-6.439-6.239-6.439zM.855 8.617c0-4.202 3.301-7.61 7.373-7.61s7.374 3.408 7.374 7.61c0 4.203-3.302 7.61-7.374 7.61-4.072 0-7.373-3.407-7.373-7.61zm7.373-2.926c.314 0 .567.262.567.585v1.756h1.702c.313 0 .567.262.567.585a.576.576 0 01-.567.586H8.795v1.756a.576.576 0 01-.567.585.576.576 0 01-.567-.585V9.204H5.96a.576.576 0 01-.568-.586c0-.323.254-.585.567-.585h1.702V6.277c0-.323.254-.585.567-.585zM13.121.4a.555.555 0 01.802 0l2.14 2.207c.22.229.22.6 0 .828a.555.555 0 01-.803 0l-2.139-2.207a.599.599 0 010-.828zM3.336.4a.555.555 0 00-.803 0L.394 2.607a.599.599 0 000 .828c.222.229.581.229.803 0l2.139-2.207a.599.599 0 000-.828z"
}));
function SvgCirculoconmas(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Circulo con mas.svg";
export { SvgCirculoconmas as ReactComponent };